import InputAdornment from "@mui/material/InputAdornment";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import { useState } from "react";
import { useNavigate } from "react-router-dom";

import Card from "@mui/material/Card";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

import BasicLayout from "layouts/BasicLayout";

import bgImage from "assets/images/bg-login.jpg";
import logo from "assets/images/logo-en.png";

import { login } from "services/User";
import useLocale from "context/useLocale";
import { DEFAULT_COUNTRY_ISO2, MENA_COUNTRIES } from "constants/countries";
import { toApiPhoneNumber } from "util/phoneNumber";

function Basic() {
  const locale = useLocale();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryIso2, setCountryIso2] = useState(DEFAULT_COUNTRY_ISO2);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();
  const selectedCountry = MENA_COUNTRIES.find((c) => c.iso2 === countryIso2) || MENA_COUNTRIES[0];

  const logoStyle = {
    display: "block",
    position: "relative",
    width: "150px",
    height: "auto",
    margin: "40px auto",
  };

  const submit = () => {
    setError("");
    login(toApiPhoneNumber(phoneNumber, countryIso2), password).then(
      (res) => {
        localStorage.setItem(
          "machinat_credentials",
          JSON.stringify({
            access_token: res.data.access_token,
            expires_in: Date.now() + res.data.expires_in * 1000,
            refresh_token: res.data.refresh_token,
          })
        );
        return navigate("/dashboard/");
      },
      (err) => setError(err.response.data.message ? err.response.data.message : "Failed to login")
    );
  };

  return (
    <BasicLayout image={bgImage}>
      <img src={logo} alt="Logo" style={logoStyle} />
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" my={1}>
            {locale("signin")}
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            <MDBox mb={2}>
              <MDInput
                type="text"
                label={locale("phone")}
                name="username"
                fullWidth
                onChange={(e) => setPhoneNumber(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Select
                        variant="standard"
                        disableUnderline
                        value={countryIso2}
                        onChange={(e) => setCountryIso2(e.target.value)}
                        sx={{ minWidth: 88, mr: 1 }}
                        renderValue={() => (
                          <MDBox display="flex" alignItems="center" gap={0.5}>
                            <span style={{ fontSize: 16 }}>{selectedCountry.flag}</span>
                            <MDTypography variant="button">
                              +{selectedCountry.dialCode}
                            </MDTypography>
                          </MDBox>
                        )}
                      >
                        {MENA_COUNTRIES.map((country) => (
                          <MenuItem key={country.iso2} value={country.iso2}>
                            <MDBox display="flex" alignItems="center" gap={1}>
                              <span>{country.flag}</span>
                              <span>{country.name.en}</span>
                              <span>+{country.dialCode}</span>
                            </MDBox>
                          </MenuItem>
                        ))}
                      </Select>
                    </InputAdornment>
                  ),
                }}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label={locale("password")}
                name="password"
                fullWidth
                onChange={(e) => setPassword(e.target.value)}
              />
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton variant="gradient" color="info" fullWidth onClick={submit}>
                {locale("login")}
              </MDButton>
            </MDBox>
            <MDTypography variant="h6" fontWeight="regular" color="error" my={1}>
              {error}
            </MDTypography>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
